export default (autoPlay = false) => ({
    duration: 0,
    currentTime: 0,
    framerate: 30,
    video: null,

    get progress() {
        return (this.currentTime / this.duration) * 100
    },

    init() {
        this.video = this.$el.querySelector('video')

        if (!this.video) {
            return
        }

        this.video.addEventListener('timeupdate', this.onTimeUpdate.bind(this))
        this.video.addEventListener(
            'loadedmetadata',
            this.onLoadedMetadata.bind(this)
        )

        if (!autoPlay) {
            return
        }

        this.observer = !!window.IntersectionObserver
            ? new IntersectionObserver(
                  (entries, observer) => {
                      for (const entry of entries) {
                          if (entry.intersectionRatio > 0) {
                              this.onIntersecting(entry.target)
                              observer.unobserve(entry.target)
                          }
                      }
                  },
                  {
                      rootMargin: '0% 0% -30% 0%',
                      threshold: 0,
                  }
              )
            : null

        if (this.observer) {
            this.observer.observe(this.video)
        } else {
            this.onIntersecting(this.video)
        }
    },

    onLoadedMetadata(event) {
        this.duration = event.target.duration

        if (this.video && !this.video.getAttribute('poster')) {
            this.video.currentTime = 0
        }
    },

    onTimeUpdate(event) {
        this.currentTime = event.target.currentTime || 0
    },

    goTo(time) {
        if (this.video) {
            this.video.currentTime = time
            this.video.play()
        }
    },

    onIntersecting(target) {
        target?.play()
    },
})
